import React from "react";
import Label from "components/general/Label"
import { filterArray, findArray, RscFromStore } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import { usePositions, useTeamAthletesOrderByPositions } from "components/common/Positions";
import Esl from "components/common/Esl";
import { getRscObject } from "helpers/rsc";

export const TableExpanded = React.memo((props) => {

    const { row } = props;
    const eventUnitType = props?.eventUnitType;

    const data = ((row?.extendedResults?.length > 0))
        ? row?.extendedResults
        : undefined

    let dataTeam = row?.teamAthletes?.some(val => val.hasOwnProperty('athlete'))
        ? row.teamAthletes
        : undefined

    dataTeam?.sort((a, b) => a.order - b.order);
    const { sex: gender } = getRscObject(RscFromStore());
    let showGender = true;


    let isTeam = props?.data?.itemType === 'T'
    let esl = props?.data?.extCompetitor;
    const positions = usePositions();
    const athletesSorts = useTeamAthletesOrderByPositions(props?.data?.teamAthletes, true);
    let intermediates = filterArray(props?.config?.extendedConfig, { code: ['INTERMEDIATE'] })
    return (
        <>

            {eventUnitType === 'TEAM' && <table className="table table-striped table-bordered w-60 m-auto">
                <tbody>
                    {dataTeam && dataTeam.map((val, key) => {
                        let res = findArray(data, { er_pos: [val.ei_pos] })
                        return (
                            <tr key={'expanded_' + val.athlete.code + '_' + key}>
                                <td className="text-start">{val.athlete.name}</td>
                                {showGender && <td className="text-start">{val.athlete.personGender.code}</td>}
                            </tr>
                        )
                    })}
                </tbody>
            </table>}

            <Esl data={esl} />
            {isTeam
                ? <div className='row-competitor-box'>{athletesSorts?.map((ath, index) =>
                    <div className='row-competitor' key={index}>
                        <Competitor {...ath.athlete} hidePicture={true} hideNoc={true} />
                        &nbsp;-&nbsp;{positions(ath?.eventUnitEntries.find(item => item.code = 'POSITION')?.eue_value)}
                    </div>
                )}</div>
                : <></>
            }
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th className="w-10"></th>
                        <th className="fw-bold text-start"><Label data="HeaderDistance" /></th>
                        <th className="fw-bold text-end w-30"><Label data="HeaderTime" /></th>
                        <th className="fw-bold text-end "><Label data="HeaderRank" sport="ROW" /></th>
                        <th className="w-20"></th>
                    </tr>
                </thead>
                <tbody>
                    {intermediates.map((int, index) => {
                        let label = int.value
                        let value = findArray(props?.data?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [int.pos] }).er_value
                        let rank = findArray(props?.data?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [int.pos] }).er_rank
                        return (
                            <tr key={index}>
                                <td></td>
                                <td className="fw-bold text-start">{int.pos === 'F'
                                    ? <Label data="HeaderFinish" />
                                    : label + 'm'}
                                </td>
                                <td className="text-end">{value}</td>
                                <td className="text-end">{rank}</td>
                                <td></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    );
});

export default TableExpanded